import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardArrowDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_arrow_down"}/>
}
